var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{
                name: 'demandOwnerSubstitutionEdit',
                params: {
                    id: item.id,
                    demandCode: item.demand.code,
                    demandId: item.demand.id
                }
            },"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.demand.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("personToString")(item.originalOwner)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("personToString")(item.substituteOwner)))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'demandOwnerSubstitutionCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t("label.createDemandOwnerSubstitutions")))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15f710f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demandOwnerSubstitutions/Index.vue
// module id = EJX4
// module chunks = 1